import { useState } from 'react'
import { Trans } from 'react-i18next'
import { toast } from 'react-toastify'
import papa from 'papaparse'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table.js'
import { Download16 } from '@makyoapp/makyo-icon/icon'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

/**
 * ExportData
 */
export function ExportData() {
  const [isLoading, setIsLoading] = useState(false)

  const { language, userSpecific } = useDbClientContext()
  const { table, activeTable } = useGridV2Context()

  /**
   * Export data from dbTable to json
   */
  const handleExportData = async () => {
    if (!activeTable) return

    setIsLoading(true)

    try {
      // get all rows
      const allRows = activeTable.GetDbWorkerRows(language, userSpecific)

      const filteredColumns = table?.columns?.filter((c) => c.type !== ColumnTypes.Slug) ?? []

      // setup all columns (including RowID)
      const allColumns = [
        {
          id: '_id',
          name: 'ID',
        },
        ...filteredColumns.map((c) => ({
          id: c.id,
          name: c.name,
        })),
      ]

      // format rows and map into column name
      const formattedRows = await Promise.all(
        allRows.map((row) => {
          const newRow: Record<string, unknown> = {}

          for (const col of allColumns) {
            newRow[col.name] = row[col.id]
          }

          return newRow
        })
      )

      const result = papa.unparse(formattedRows, {
        columns: allColumns.map((c) => c.name),
        header: true,
      })

      const file = new File([result], `${table?.name || 'table'}.csv`, {
        type: 'text/plain:charset=UTF-8',
      })
      //create a ObjectURL in order to download the created file
      const url = URL.createObjectURL(file)

      //create a hidden link and set the href and click it
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.download = file.name
      a.click()
      URL.revokeObjectURL(url)
    } catch (err) {
      toast.error('Failed to export data')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <button onClick={handleExportData} className='mk-ddi flex-c mk-dd-row'>
      <Download16 />
      <div>{isLoading ? <span className='loading' /> : <Trans>Export as CSV</Trans>}</div>
    </button>
  )
}
